import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'edit-pdf-section-modal',
  templateUrl: './edit-pdf-section-modal.component.html',
})
export class EditPdfSectionModalComponent implements OnInit {
  selectedDocument = null;

  constructor(
    private activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

  public onFileChange(event) {
    if (event.target.files.length > 0) {
      this.selectedDocument = event.target.files[0];
    }
  }

  public submit() {
    this.activeModal.close(({
      document: this.selectedDocument
    }));
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
